<div
  class="px-3 pt-3 pb-2 m-0"
  [appAlertStyle]="severity"
  [ngClass]="{ 'cursor-pointer': count > 0 }"
  (click)="showDetails()">
  <div class="flex gap-2 pb-2 font-bold align-items-center">
    <i [class]="icon"></i> {{ label }}
  </div>
  <div class="py-3 text-7xl">
    {{ count }}
  </div>
  @if (text) {
    <div class="flex align-items-center gap-3">
      <i class="text-5xl" [class]="getIconBySeverity()"></i>
      <div [innerHTML]="text"></div>
    </div>
  }
  <div class="text-right py-2" *ngIf="count > 0">
    <a>Details <i class="fas fa-arrow-right"></i></a>
  </div>
</div>
